import { render, staticRenderFns } from "./DownloadCatalog.vue?vue&type=template&id=d5c8125a&scoped=true&"
import script from "./DownloadCatalog.vue?vue&type=script&lang=js&"
export * from "./DownloadCatalog.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCatalog.vue?vue&type=style&index=0&id=d5c8125a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c8125a",
  null
  
)

export default component.exports